import { useCallback, useEffect, useRef, useState } from 'react';
import { TextField, TextFieldProps, InputAdornment, IconButton } from "@mui/material"

import { SearchIcon, ClearIcon } from 'shared/icons';

type SearchWordFieldProps = {
  searchWord: string
  onChangeSearchWord: (searchWord: string) => void
} & TextFieldProps
export const SearchWordField = ({
  searchWord,
  onChangeSearchWord,
  ...others
}: SearchWordFieldProps) => {
  const inputTimer = useRef<NodeJS.Timeout | null>(null)
  const [inputSearchWord, setInputSearchWord] = useState(searchWord)

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (inputTimer.current) clearTimeout(inputTimer.current)
      inputTimer.current = setTimeout(() => {
        onChangeSearchWord(event.target.value)
        inputTimer.current = null;
      }, 500);
      setInputSearchWord(event.target.value)
    },
    [onChangeSearchWord, setInputSearchWord]
  )
  useEffect(
    () => setInputSearchWord(searchWord),
    [searchWord]
  )
  return (
    <TextField
      {...others}
      hiddenLabel
      placeholder="検索.."
      variant="outlined"
      size="small"
      InputProps={{
        sx: {
          paddingRight: 0
        },
        endAdornment: (
          <InputAdornment position="end" sx={{ marginLeft: 0 }}>
            { inputSearchWord === '' ? (
              <IconButton
                type="button"
                aria-label="search"
                onClick={() => {
                  // no action
                }}
              >
                <SearchIcon />
              </IconButton>
            ) : (
              <IconButton
                type="button"
                aria-label="search-clear"
                onClick={() => {
                  setInputSearchWord('');
                  onChangeSearchWord('');
                }}
              >
                <ClearIcon />
              </IconButton>
            ) }
          </InputAdornment>
        )
      }}
      value={inputSearchWord}
      onChange={onChange}
    />
  );
}